import axios from 'axios'

const api = axios.create({
  baseURL: process.env.REACT_APP_BASE_API_URL || 'https://sshagentservice.onrender.com',
  timeout: 30000,
})

const getAuthToken = () => {
  return localStorage.getItem('authToken')
}

const getAuthHeaders = () => {
  const token = getAuthToken()
  return {
    Authorization: token ? `Bearer ${token}` : '',
  }
}

api.interceptors.request.use(
  config => {
    const token = getAuthToken()
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

// Add response interceptor for better error handling
api.interceptors.response.use(
  response => {
    return response
  },
  error => {
    if (error.response?.status === 401) {
      localStorage.removeItem('authToken')
      window.location.href = '/login'
    }
    return Promise.reject(error)
  }
)

export default api

export const fetchUser = userId => {
  return api.get(`/v1/admin/profile/${userId}`)
}

export const createUser = userData => {
  return api.post('/v1/admin/create', userData, {
    headers: {
      'Content-Type': 'application/json',
    },
  })
}

export const updateUser = userData => {
  return api.patch('/v1/admin/settings/profile', userData, {
    headers: {
      'Content-Type': 'application/json',
    },
  })
}

export const uploadProfilePhoto = photoFile => {
  const formData = new FormData()
  formData.append('photo', photoFile)

  return api.post('/v1/admin/profile/photo', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })
}

export const deleteUser = userId => {
  return api.delete(`/v1/admin/users/${userId}`)
}
